import { DynamicIconType } from '@allesauto/utils/consts';
import {
  Application32,
  BatteryCharging32,
  Calendar32,
  Car32,
  CarFront32,
  Certificate32,
  CertificateCheck32,
  ChartLine32,
  Chat32,
  CheckmarkOutline32,
  CirclePacking32,
  ColorPalette32,
  Compass32,
  Concept32,
  Connect32,
  CurrencyEuro32,
  DataCheck32,
  DecisionTree32,
  Delivery32,
  Development32,
  Document32,
  Error32,
  FaceSatisfied32,
  FaceWink32,
  Grid32,
  HelpDesk32,
  Home32,
  Idea32,
  Location32,
  LocationHeart32,
  LogoFacebook32,
  MagicWand32,
  Money32,
  Mountain32,
  NextOutline32,
  NotificationNew32,
  OperationsRecord32,
  Partnership32,
  PersonFavorite32,
  PhoneFilled32,
  Rocket32,
  Scan32,
  Search32,
  ServiceDesk32,
  Shuffle32,
  Snowflake32,
  Star32,
  Store32,
  Switcher32,
  Template32,
  Time32,
  Timer32,
  Unlocked32,
  UserCertification32,
  UserFavoriteAlt32,
  UserMultiple32,
  WarningAlt32,
  WatsonHealth3DCursorAlt32,
  WatsonHealthRotate_18032,
  Wikis32,
  Workspace32,
  ZoomReset32,
} from '@carbon/icons-react';
import dynamic from 'next/dynamic';
import React from 'react';

const SecurityServices = dynamic(
  () => import('@allesauto/design/graphics/security-services.svg')
);
const UserServiceDesk = dynamic(
  () => import('@allesauto/design/graphics/user--service-desk.svg')
);
const VehicleServices32 = dynamic(
  () => import('@allesauto/design/graphics/vehicle--services.svg')
);

const Kununu32 = dynamic(() => import('@allesauto/design/svg/Kununu.svg'));
const LinkedIn32 = dynamic(() => import('@allesauto/design/svg/LinkedIn.svg'));
const Xing32 = dynamic(() => import('@allesauto/design/svg/Xing.svg'));

const DynamicIconComponents = {
  application: Application32,
  batteryCharging: BatteryCharging32,
  calendar: Calendar32,
  car: Car32,
  carFront: CarFront32,
  certificate: Certificate32,
  certificateCheck: CertificateCheck32,
  chart: ChartLine32,
  chat: Chat32,
  checkmark: CheckmarkOutline32,
  circle: CirclePacking32,
  colorPalette: ColorPalette32,
  compass: Compass32,
  concept: Concept32,
  connect: Connect32,
  currencyEuro: CurrencyEuro32,
  dataCheck: DataCheck32,
  decisionTree: DecisionTree32,
  delivery: Delivery32,
  development: Development32,
  document: Document32,
  faceSatisfied: FaceSatisfied32,
  faceWink: FaceWink32,
  favorite: UserFavoriteAlt32,
  grid: Grid32,
  home: Home32,
  helpDesk: HelpDesk32,
  idea: Idea32,
  location: Location32,
  locationHeart: LocationHeart32,
  logoFacebook: LogoFacebook32,
  magicWand: MagicWand32,
  money: Money32,
  mountain: Mountain32,
  nextArrow: NextOutline32,
  notificationNew: NotificationNew32,
  partnership: Partnership32,
  personFavorite: PersonFavorite32,
  phoneFilled: PhoneFilled32,
  record: OperationsRecord32,
  rocket: Rocket32,
  rotate180: WatsonHealthRotate_18032,
  scan: Scan32,
  search: Search32,
  securityServiceDesk: SecurityServices,
  serviceDesk: ServiceDesk32,
  shuffle: Shuffle32,
  snowFlake: Snowflake32,
  star: Star32,
  store: Store32,
  switcher: Switcher32,
  template: Template32,
  time: Time32,
  timer: Timer32,
  unlocked: Unlocked32,
  user: UserMultiple32,
  userCertification: UserCertification32,
  userFavorite: UserFavoriteAlt32,
  userServiceDesk: UserServiceDesk,
  vehicleServices: VehicleServices32,
  watsonHealth: WatsonHealth3DCursorAlt32,
  warning: WarningAlt32,
  wiki: Wikis32,
  workspace: Workspace32,
  linkedin: LinkedIn32,
  xing: Xing32,
  kununu: Kununu32,
  zoomReset: ZoomReset32,
};

export interface IDynamicIconProps {
  icon: DynamicIconType;
  customClassName?: string;
}

function DynamicIcon({ icon, customClassName = '' }: IDynamicIconProps) {
  const IconComponent = DynamicIconComponents[icon] ?? Error32;
  return <IconComponent className={customClassName} />;
}

export default DynamicIcon;
